import { Link } from 'react-router-dom';

interface ServiceItem {
  id: string;
  icon: string;
  title: string;
  description: string;
  features: string[];
}

interface ServicesProps {
  services: ServiceItem[];
}

export default function Services({ services }: ServicesProps) {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 font-heading mb-4">
            核心服务
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            四大核心服务板块，全方位满足您的文件起草与官网建设需求
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {services.map((service) => (
            <div
              key={service.id}
              className="bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/70 hover:border-primary-200 transition-all duration-300 group"
            >
              <div className="flex items-start gap-5">
                <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-500 transition-colors duration-300">
                  <i className={`${service.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`} />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg md:text-xl font-bold text-foreground-900 font-heading mb-2">
                    {service.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    {service.description}
                  </p>
                  <div className="flex flex-wrap gap-2 mb-4">
                    {service.features.map((feature) => (
                      <span
                        key={feature}
                        className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs font-medium"
                      >
                        {feature}
                      </span>
                    ))}
                  </div>
                  <Link
                    to={`/category/${service.id}`}
                    className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
                  >
                    了解更多
                    <i className="ri-arrow-right-line" />
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}